export default {
      id: "信永中和logo@3x备份-usage",
      viewBox: "0 0 69 39",
      url: __webpack_public_path__ + "img/icons.a5c507dd.svg#信永中和logo@3x备份",
      toString: function () {
        return this.url;
      }
    }